import React from "react";
import { useTranslation } from "react-i18next";
import { ActionButton, ModalBuilder } from "@redriver/cinnamon";
import { UserType } from "features/../../../shared/constants/enums";
import { deleteMasterAgreement } from "../actions";
import { Targets, Actions } from "constants/permissions";
import {
  PermissionCheck,
  UserTypeCheck,
} from "features/../../../shared/components/auth";
import { TranslatedModal } from "features/../../../shared/components/modals";

const DeleteMasterAgreement = ({
  agreementId,
  agreementReference,
  onSubmitted,
}) => {
  const { t } = useTranslation("agreements");

  return (
    <div className="float-left spaced">
      <UserTypeCheck restrictTo={UserType.HQ}>
        <PermissionCheck target={Targets.Agreements} action={Actions.Delete}>
          <ModalBuilder
            submitAction={deleteMasterAgreement}
            submitParams={{ id: agreementId }}
            onSubmitted={onSubmitted}
            renderTrigger={(showModal) => (
              <ActionButton
                type="delete"
                onClick={showModal}
                className="action-button"
              />
            )}
            renderModal={(modalProps) => (
              <TranslatedModal.Delete
                {...modalProps}
                header={t("AgreementRow.Delete_Header")}
                size="tiny"
              >
                {t("AgreementRow.Delete_Confirm", {
                  ref: agreementReference,
                })}
              </TranslatedModal.Delete>
            )}
          ></ModalBuilder>
        </PermissionCheck>
      </UserTypeCheck>
    </div>
  );
};

export default DeleteMasterAgreement;
